const TOPICS = [
  { id: 1, name: '明星恋情', count: '128.5万', hot: true },
  { id: 2, name: '网红翻车', count: '96.2万', hot: true },
  { id: 3, name: '综艺内幕', count: '83.7万', hot: true },
  { id: 4, name: '直播塌房', count: '71.4万', hot: false },
  { id: 5, name: '娱乐圈黑幕', count: '68.9万', hot: false },
  { id: 6, name: '体育八卦', count: '55.3万', hot: false },
  { id: 7, name: '电竞吃瓜', count: '49.8万', hot: true },
  { id: 8, name: '海外爆料', count: '42.1万', hot: false },
  { id: 9, name: '日常吃瓜', count: '38.6万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            话题广场
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-3">点击话题，即刻吃瓜</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <span
              key={topic.id}
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm transition-all duration-200 bg-background-50 border-background-200/70 text-foreground-700 hover:border-primary-300 hover:text-primary-600 hover:bg-primary-50/50"
            >
              {topic.hot && <i className="ri-fire-fill text-primary-500 text-sm"></i>}
              <span className="font-medium">{topic.name}</span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}